import { Base, BaseProps } from '../Base'

export function InfoColor(props: BaseProps): JSX.Element {
  return (
    <Base {...props} w="57" h="45" viewBox="0 0 57 45">
      <svg fill="none">
        <path
          d="M21.642 44.2349C33.5945 44.2349 43.284 34.5455 43.284 22.5929C43.284 10.6404 33.5945 0.950928 21.642 0.950928C9.68945 0.950928 0 10.6404 0 22.5929C0 34.5455 9.68945 44.2349 21.642 44.2349Z"
          fill="#E0EEFA"
        />
        <path
          d="M18.5 24.188C19.3284 24.188 20 23.5164 20 22.688C20 21.8596 19.3284 21.188 18.5 21.188C17.6716 21.188 17 21.8596 17 22.688C17 23.5164 17.6716 24.188 18.5 24.188Z"
          fill="#0189FF"
        />
        <path
          d="M23.5 24.188C24.3284 24.188 25 23.5164 25 22.688C25 21.8596 24.3284 21.188 23.5 21.188C22.6716 21.188 22 21.8596 22 22.688C22 23.5164 22.6716 24.188 23.5 24.188Z"
          fill="#0189FF"
        />
        <path
          d="M28.5 24.188C29.3284 24.188 30 23.5164 30 22.688C30 21.8596 29.3284 21.188 28.5 21.188C27.6716 21.188 27 21.8596 27 22.688C27 23.5164 27.6716 24.188 28.5 24.188Z"
          fill="#0189FF"
        />
        <path
          d="M43.678 13.971C40.657 8.72199 34.991 5.18799 28.5 5.18799C18.835 5.18799 11 13.023 11 22.688C11 32.353 18.835 40.188 28.5 40.188C34.608 40.188 39.984 37.059 43.115 32.317"
          stroke="#808080"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47 21.188H50C50.2652 21.188 50.5196 21.2933 50.7071 21.4809C50.8946 21.6684 51 21.9228 51 22.188V29.233H51.237C51.4908 29.2411 51.7316 29.3477 51.9082 29.5301C52.0849 29.7125 52.1837 29.9565 52.1837 30.2105C52.1837 30.4645 52.0849 30.7085 51.9082 30.8909C51.7316 31.0733 51.4908 31.1799 51.237 31.188H46.977C46.7232 31.1799 46.4824 31.0733 46.3058 30.8909C46.1291 30.7085 46.0303 30.4645 46.0303 30.2105C46.0303 29.9565 46.1291 29.7125 46.3058 29.5301C46.4824 29.3477 46.7232 29.2411 46.977 29.233H47V23.311C46.7348 23.311 46.4804 23.2056 46.2929 23.0181C46.1054 22.8306 46 22.5762 46 22.311V22.188C46 21.9228 46.1054 21.6684 46.2929 21.4809C46.4804 21.2933 46.7348 21.188 47 21.188Z"
          fill="#0189FF"
        />
        <path
          d="M49 19.188C50.3807 19.188 51.5 18.0687 51.5 16.688C51.5 15.3073 50.3807 14.188 49 14.188C47.6193 14.188 46.5 15.3073 46.5 16.688C46.5 18.0687 47.6193 19.188 49 19.188Z"
          fill="#0189FF"
        />
      </svg>
    </Base>
  )
}

InfoColor.displayName = 'InfoColor'
